import { Text } from '@chakra-ui/react';

type ClearFilterProps = {
  text: string;
  isVisible?: boolean;
  onClear: () => void;
};

export const ClearFilter = (props: ClearFilterProps) => {
  if (!props.isVisible) {
    return null;
  }

  const onClearClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    props.onClear();
  };

  return (
    <Text
      color={'var(--chakra-colors-typography-hyperlink)'}
      fontSize={'sm'}
      fontWeight={'medium'}
      onClick={onClearClick}
      cursor={'pointer'}
    >
      {props.text}
    </Text>
  );
};
